module.exports = __webpack_public_path__ + "img/bg-pic2.32bb186a.png";